<!-- src/components/Request/ChangeStatusDialog.vue -->
<template>
    <v-dialog
      v-model="dialogModel"
      max-width="500px"
      persistent
    >
      <v-card>
        <v-card-title :class="`text-h5 ${statusColor} text-white`">
          <v-icon left>{{ statusIcon }}</v-icon>
          {{ dialogTitle }}
        </v-card-title>
        
        <v-card-text class="pt-4">
          <v-alert
            type="info"
            prominent
            class="mb-4"
          >
            Você está prestes a alterar o status desta requisição.
          </v-alert>
          
          <v-card v-if="request" outlined class="mt-3 pa-4">
            <v-row dense>
              <v-col cols="4" class="font-weight-bold">Código:</v-col>
              <v-col cols="8">{{ request.code }}</v-col>
            </v-row>
            
            <v-divider class="my-2"></v-divider>
            
            <v-row dense>
              <v-col cols="4" class="font-weight-bold">Descrição:</v-col>
              <v-col cols="8">{{ request.description }}</v-col>
            </v-row>
            
            <v-divider class="my-2"></v-divider>
            
            <v-row dense>
              <v-col cols="4" class="font-weight-bold">Status Atual:</v-col>
              <v-col cols="8">
                <v-chip
                  small
                  :color="statusColor"
                  text-color="white"
                >
                  {{ currentStatusText }}
                </v-chip>
              </v-col>
            </v-row>
            
            <v-divider class="my-2"></v-divider>
            
            <v-row dense>
              <v-col cols="4" class="font-weight-bold">Novo Status:</v-col>
              <v-col cols="8">
                <v-chip
                  small
                  :color="statusColor"
                  text-color="white"
                >
                  {{ nextStatusText }}
                </v-chip>
              </v-col>
            </v-row>
          </v-card>
        </v-card-text>
        
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="grey darken-1"
            text
            @click="closeDialog"
          >
            Cancelar
          </v-btn>
          <v-btn
            color="primary"
            text
            :loading="loading"
            @click="confirmStatusChange"
          >
            Confirmar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </template>
  
  <script>
  import { REQUEST_STATUS } from '@/helpers/constants/app.constants';
  import { mapActions } from 'vuex';

  export default {
    name: 'ChangeStatusDialog',
    
    props: {
      value: {
        type: Boolean,
        default: false
      },
      request: {
        type: Object,
        default: null
      }
    },
    
    data() {
      return {
        loading: false,
        comments: ''
      };
    },
    
    computed: {
      dialogModel: {
        get() {
          return this.value;
        },
        set(value) {
          this.$emit('input', value);
        }
      },

      statusColor() {
        const statusColors = {
          [REQUEST_STATUS.PENDING]: 'blue',
          [REQUEST_STATUS.IN_PURCHASE]: 'amber darken-2',
          [REQUEST_STATUS.WAITING_APPROVAL]: 'purple',
          [REQUEST_STATUS.APPROVED]: 'green',
          [REQUEST_STATUS.DENIED]: 'red',
          [REQUEST_STATUS.RETURNED]: 'orange',
          [REQUEST_STATUS.DELIVERED]: 'teal',
          [REQUEST_STATUS.COMPLETED]: 'green darken-3'
        };
        
        return statusColors[this.request.status] || 'grey';
      },

      currentStatusText() {        
        return REQUEST_STATUS[this.request.status].label || 'Desconhecido';
      },
      
      nextStatusText() {
        return REQUEST_STATUS[this.request.status].nextStatusLabel || 'Desconhecido';
      },
      
      statusIcon() {
        const statusIcons = {
          [REQUEST_STATUS.PENDING]: 'mdi-clock-outline',
          [REQUEST_STATUS.IN_PURCHASE]: 'mdi-cart',
          [REQUEST_STATUS.WAITING_APPROVAL]: 'mdi-account-clock',
          [REQUEST_STATUS.APPROVED]: 'mdi-check-circle',
          [REQUEST_STATUS.DENIED]: 'mdi-close-circle',
          [REQUEST_STATUS.RETURNED]: 'mdi-keyboard-return',
          [REQUEST_STATUS.DELIVERED]: 'mdi-truck-delivery',
          [REQUEST_STATUS.COMPLETED]: 'mdi-check-all'
        };
        
        return statusIcons[this.request.status] || 'mdi-help-circle';
      },
    },
    
    methods: {
        ...mapActions('request', ['updateStatus']),
      
      dialogTitle() {
        switch (this.request.status) {
          case REQUEST_STATUS.APPROVED:
            return 'Aprovar Requisição';
          case REQUEST_STATUS.DENIED:
            return 'Negar Requisição';
          case REQUEST_STATUS.RETURNED:
            return 'Devolver Requisição';
          case REQUEST_STATUS.IN_PURCHASE:
            return 'Iniciar Compra';
          case REQUEST_STATUS.WAITING_APPROVAL:
            return 'Enviar para Aprovação';
          case REQUEST_STATUS.DELIVERED:
            return 'Marcar como Entregue';
          case REQUEST_STATUS.COMPLETED:
            return 'Concluir Requisição';
          default:
            return 'Alterar Status da Requisição';
        }
      },
      
      closeDialog() {
        this.dialogModel = false;
        this.$emit('close');
      },
      
      async confirmStatusChange() {
        this.loading = true;
        
        try {
          const { success, error } = await this.updateStatus({ requestId: this.request.id, status: REQUEST_STATUS[this.request.status].nextStatus })
          
          if (success) {
            this.closeDialog();
            this.$emit('snackbar', {
              color: 'success',
              text: `Status da requisição ${this.request.code} alterado com sucesso!`
            });
          } else {
            this.$emit('snackbar', {
              color: 'error',
              text: `Erro ao alterar status da requisição: ${error}`
            });
          }
        } catch (error) {
          console.error('Erro ao alterar status da requisição:', error);
          this.$emit('snackbar', {
            color: 'error',
            text: 'Ocorreu um erro ao alterar o status da requisição.'
          });
        } finally {
          this.loading = false;
        }
      }
    }
  };
  </script>